import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4M15 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4M11 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M15 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4M11 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0M15 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    }, null, -1)
  ])))
}
export default { render: render }